import { render, staticRenderFns } from "./AppHeaderLogout.vue?vue&type=template&id=b0e78254"
import script from "./AppHeaderLogout.vue?vue&type=script&lang=js"
export * from "./AppHeaderLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports